import { useRouter } from "next/router";
import useCreateCustomerInformation from "./useCreateCustomerInformation";
import { SellerQueryParams } from "../types";

const useSellerInfoFromQuery = () => {
  const router = useRouter();
  const {
    sellerFirst: firstName,
    sellerLast: lastName,
    sellerAddress: streetAddress,
    sellerCity: city,
    sellerProvince: provinceAbbr,
    sellerPostal: postalCode,
    sellerPhoneNumber: phoneNumber,
    sellerEmail: email,
  } = router.query as SellerQueryParams;

  const sellerInformation = useCreateCustomerInformation({
    firstName,
    lastName,
    streetAddress,
    city,
    provinceAbbr,
    postalCode,
    phoneNumber,
    email,
  });

  return sellerInformation;
};

export default useSellerInfoFromQuery;
